/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  setSelectedStatusAction,
  setSelectedModelAction,
  setSelectedStateAction,
  setSelectedParentAction,
  setSelectedTechnologyAction,
  setSearchKeywordAction,
  setSelectedViewAction,
  setRegionFilterIdsAction,
  resetInventoryFiltersAction,
} from "./actions";
import { IInventoryFilterState } from "../types";

const initialState: IInventoryFilterState = {
  selectedView: "radionodes", // Default to RadioNodes tab
  regionFilterIds: [],
};

const inventoryFilterSlice = createSlice({
  name: "inventoryFilter",
  initialState,
  reducers: {
    setSelectedStatus: setSelectedStatusAction,
    setSelectedModel: setSelectedModelAction,
    setSelectedState: setSelectedStateAction,
    setSelectedParent: setSelectedParentAction,
    setSelectedTechnology: setSelectedTechnologyAction,
    setSearchKeyword: setSearchKeywordAction,
    setSelectedView: setSelectedViewAction,
    setRegionFilterIds: setRegionFilterIdsAction,
    resetInventoryFilters: resetInventoryFiltersAction,
  },
});

export const InventoryFilterReducer = inventoryFilterSlice.reducer;

export const {
  setSelectedStatus,
  setSelectedModel,
  setSelectedState,
  setSelectedParent,
  setSelectedTechnology,
  setSearchKeyword,
  setSelectedView,
  setRegionFilterIds,
  resetInventoryFilters,
} = inventoryFilterSlice.actions;
